(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.service('$m', function($ocLazyLoad, $injector, $q) {
    var $m = this;

    // unless가 true인 경우에는, module을 laoding하지 않는다.
    $m.$invokeWithModule = function(module, fn, unless) {
      if (unless) {
        var locals = {};
        angular.forEach($injector.annotate(fn), function(name) {
          if (!$injector.has(name)) {
            locals[name] = {};
          }
        });
        return $q.when($injector.invoke(fn, null, locals));
      }

      return $ocLazyLoad.load(module).then(function() {
        return $injector.invoke(fn);
      });
    };

    // $invokeWithModule syntax sugar
    $m.$invokeWithModuleIf = function(cond, module, fn) {
      return $m.$invokeWithModule(module, fn, !cond);
    };

    $m.$withLazyModule = function(lazyModules, lazyServices, fn) {
      var inject = [];
      angular.forEach($injector.annotate(fn), function(svc) {
        if (lazyServices.indexOf(svc) < 0) {
          inject.push(svc);
        }
      });
      var tmpFn = function() {
        var locals = {};
        for (var i = 0; i < inject.length; i++) {
          locals[inject[i]] = arguments[i];
        }
        return $ocLazyLoad.load(lazyModules).then(function() {
          $injector.invoke(fn, null, locals);
        });
      };
      tmpFn.$inject = inject;
      return tmpFn;
    }
  });
})(window, window.angular);
